// Shared 18-swatch color palette used by both the label editor (AddLabel) and
// the team editor (AddTeam). Each entry pairs a hex fill with the `darkText`
// flag that keeps the chip text legible on that fill. Single source of truth —
// do not duplicate this list; import it wherever a color picker is rendered.
const labelColors = [
  { color: '#B01E8A', darkText: false },
  { color: '#C3F6E9', darkText: true },
  { color: '#2EC0FC', darkText: false },
  { color: '#CCB2FD', darkText: true },
  { color: '#D2F7C6', darkText: true },
  { color: '#FDD576', darkText: true },
  { color: '#9DC9FF', darkText: true },
  { color: '#D44D2D', darkText: false },
  { color: '#FEDCE5', darkText: true },
  { color: '#F69FE0', darkText: true },
  { color: '#3282F5', darkText: false },
  { color: '#FDE9B8', darkText: true },
  { color: '#000000', darkText: false },
  { color: '#666666', darkText: false },
  { color: '#31D8D1', darkText: false },
  { color: '#CCCCCC', darkText: true },
  { color: '#8A4FFB', darkText: false },
  { color: '#388822', darkText: false },
];

// eslint-disable-next-line import/prefer-default-export
export { labelColors };
